import axios from 'axios'

const baseURL = process.env.VUE_APP_DROP_ORDER_SERVICE + '/api/admin/settings'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getSettings ({
      state,
      commit
    }) {
      return axios.get(baseURL)
    },
    async saveSettings ({
      state,
      commit
    }, data) {
      return axios.post(baseURL, data)
    }
  }
}
